// @flow

import './RushData.css';
import rushData from './data/rushData.json';
import { setRefresh } from 'helpers/functions';
import Filter from './components/Filter';
import Chart from './components/Chart';

import React, { PureComponent } from 'react';

type State = {
  dataSet: Array<any>,
  title: string,
  value: number,
  loaded: boolean
};

export class RushData extends PureComponent<{}, State> {
  state = {
    dataSet: [],
    title: '',
    value: 0,
    loaded: false
  };

  componentDidMount() {
    const dataSet = rushData[0][1];
    const title = rushData[0][0];
    setRefresh(null);
    this.setState({ dataSet, title });
  }

  filterData = (value: string) => {
    const dataSet = rushData[value][1];
    const title = rushData[value][0];
    this.setState({ dataSet, title, value })
  }

  render() {
    return (
      <div id="rush-data-container">
        <Filter value={this.state.value} filterData={this.filterData} />
        <Chart dataSet={this.state.dataSet} title={this.state.title} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/DataApp/components/RushData/RushData.js